var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 165,
    viewBox: "0 0 110 165",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BD99B97C-CC37-467F-8B1A-E6D280A84796") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.583a2 2 0 0 1 1.231-1.846L13.027.822a10 10 0 0 1 4.109-.766l90.917 2.393A2 2 0 0 1 110 4.448V133a2 2 0 0 1-2 2H90v27.369a1.998 1.998 0 0 1-2.535 1.927L2.929 140.814A4 4 0 0 1 0 136.96V7.583z",
    fill: "#CC9543"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.542 64.871L12.57 74.724l14.879 15.255M59.891 68.003l14.888 12.744-14.981 12.364M37.384 95.964L51.2 62.138"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.606 2.748a3.174 3.174 0 0 1 1.332-.207l81.176 4.846a2 2 0 0 1 1.881 2.002l-.357 132.098a1.998 1.998 0 0 1-2.251 1.979L90 141.9V22.355a2 2 0 0 0-1.724-1.981L6.916 9.017a.499.499 0 0 1-.11-.961l13.8-5.308z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.095 154.503a1.999 1.999 0 0 0 2.405-1.959V15.547a2 2 0 0 0-1.787-1.989L15 4.904 6.806 8.056a.5.5 0 0 0 .11.961l81.36 11.357A2 2 0 0 1 90 22.355V153.45l5.095 1.053z",
    fill: "#EEE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoook);
export default __webpack_public_path__ + "static/media/boook.410eeebc0e2c5d9686b49c770575f4a1.svg";
export { ForwardRef as ReactComponent };